import React from 'react'
import { Trans } from '@lingui/macro'

import classes from './ReconnectingText.module.scss'

type ReconnectingTextProps = {
  isReady: boolean
  secondsLeft: number
}

export const ReconnectingText = (props: ReconnectingTextProps) => {
  const { isReady, secondsLeft } = props

  return (
    <p className={classes.ReconnectingText}>
      {isReady ? (
        <Trans>Reconnecting...</Trans>
      ) : (
        <Trans values={{ secondsLeft }}>
          Reconnecting in {secondsLeft} seconds...
        </Trans>
      )}
    </p>
  )
}
